import { createStyles, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  byWhenDateElem: {
    marginTop: "15px",
  },
  essentialSupportRadio: {
    border: "1px solid #E0E0E0",
    padding: 10,
    borderRadius: "10px",
    width: "200px",
  },
  essentialSupportFieldBox: {
    border: "1px solid #E0E0E0",
    padding: 10,
    borderRadius: "10px",
  },
  essentialActivities: {
    border: "1px solid rgba(0,0,0,0.1)",
    width: "100%",
    height: "auto",
    borderRadius: "5px",
    marginTop:"20px"
  },
  oneA: {
    backgroundColor: "#e5e5e5",
    padding: "5px 15px",
  },
  statementAndSupport: {
    padding: "10px 15px",
    backgroundColor: "#fcfcfc",
  },
  statementSupportParent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "15px",
    "@media (max-width:992px)": {
      display: "block",
      textAlign: "-webkit-center",
    },
  },
  statementSupportTextArea: {
    width: "100%",
    backgroundColor: "#fcfcfc",
    borderRadius: "5px",
  },
  supportBox: {
    width: "50%",
    "@media (max-width:992px)": {
      width: "100%",
    },
  },
  instructionsBox: {
    "@media (max-width:992px)": {
      marginTop: "10px",
    },
  },
  addSupportDetails: {
    width: "100%",
    backgroundColor: "#000000",
    color: "#ffffff",
    borderRadius: "5px",
    fontSize: "small",
    marginTop: "10px",
    padding: "10px 0",
    border: "none",
    cursor: "pointer",
  },
  saveButton: {
    width: "100%",
    backgroundColor: "#000000",
    color: "#ffffff",
    borderRadius: "5px",
    fontSize: "small",
    marginTop: "10px",
    padding: "15px 0",
    border: "none",
    cursor: "pointer",
  },
  addNewActivityParent: {
    textAlign: "right",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    padding: "10px 0",
  },
  addNewActivity: {
    border: "none",
    backgroundColor: "#fab005",
    cursor: "pointer",
    color: "#ffffff",
    fontSize: "25px",
    fontWeight: "bold",
    borderRadius: "3px",
    marginTop: "10px",
    "&:hover": {
      backgroundColor: "#f59f00",
    },
  },
  addInfo: {
    marginTop: "5px",
  },
  essentialSupportNumberBox:{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#f6f6f6",
    paddingInline: "10px",
    borderRadius: "5px",
    marginBottom: "10px",
    gap: "10px",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  }
}));

export default useStyles;
